import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '@library/modules/auth';
import { UserAccessGuard } from '@library/modules/user';

import {
   TermsAgreeComponent,
   TermsViewComponent,
} from '@library/modules/menu';

import { MenuComponent } from '@ap/components/menu/menu.component';
import { DashboardComponent } from '@ap/components/dashboard/dashboard.component';

const routes: Routes = [
   { path: 'termsagree', component: TermsAgreeComponent },

   { path: '', component: MenuComponent,
      canActivate: [ AuthGuard ],
      canActivateChild: [ AuthGuard, UserAccessGuard ],
      children: [
         { path: 'dashboard', component: DashboardComponent },
         { path: 'terms', component: TermsViewComponent },
         {
            path: 'user',
            loadChildren: () => import( '@library/modules/user' ).then(m => m.UserModule),
            canLoad: [ AuthGuard ],
         },
         {
            path: 'activityfeed',
            loadChildren: () => import('@library/modules/activityfeed').then(m => m.ActivityfeedModule),
            canLoad: [ AuthGuard ],
            // data: { access: 'tracking' },
         },

         { path: 'admin', loadChildren: () => import( './components/admin/admin.module' ).then( m => m.AdminModule ) },

         {
            path: 'utility',
            loadChildren: () => import('./components/utility/utility.module').then(m => m.UtilityModule),
            data: { access: 'utility' },
         },

         {
            path: 'maintenance',
            loadChildren: () => import('./components/maintenance/maintenance.module').then(m => m.MaintenanceModule),
            data: { access: 'maintenance' },
         },

         {
            path: 'email-logs',
            loadChildren: () => import('./components/email-logs/email-logs.module').then(m => m.EmailLogsModule),
            data: { access: 'email_logs' },
         }
      ]
   },

   { path: '', loadChildren: () => import('@library/modules/login').then(m => m.LoginModule), },

   { path: '**', redirectTo: '/' },
];

@NgModule({
   imports: [ RouterModule.forRoot(
         routes,
         {
             anchorScrolling: 'enabled',
             scrollPositionRestoration: 'enabled',
             // enableTracing: true,
             paramsInheritanceStrategy: 'always',
         }
    )],
   exports: [RouterModule]
})
export class AppRoutingModule { }
